import { render, staticRenderFns } from "./EscalaFee.vue?vue&type=template&id=71972ee7&"
import script from "./EscalaFee.vue?vue&type=script&lang=js&"
export * from "./EscalaFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports